import { router } from '@codesuma/baseline'

// Verified https links (Android App Links / iOS Universal Links): when the OS
// hands the app a papalist.app URL, navigate to it in-app — 'appUrlOpen' while
// running, the launch URL on cold start. Web is a no-op (the browser already
// navigated). The custom-scheme OAuth callback is handled in supabase.ts; the
// two listeners ignore each other's URLs.
//
// Capacitor (native) access via the injected global — matches push.ts.
const cap = () => (window as any).Capacitor
const plugin = () => cap()?.isNativePlatform?.() ? cap()?.Plugins?.App : null

const HOST = 'papalist.app'

// Cold start can deliver the same URL twice (appUrlOpen + getLaunchUrl) —
// remember it briefly so we don't route (and animate) the same page twice,
// without swallowing a genuine later tap on the same link.
let recent = ''

const routeUrl = (url?: string) => {
    if (!url || url === recent) return
    try {
        const u = new URL(url)
        if (u.protocol !== 'https:' || u.hostname !== HOST) return
        recent = url
        setTimeout(() => { recent = '' }, 3000)
        router.goto(u.pathname)
    } catch { /* not a parseable URL — ignore */ }
}

// Boot: attach before any await so a cold-start event can't slip past, then
// pick up the launch URL for platforms that only expose it that way.
const init = async (): Promise<void> => {
    const app = plugin()
    if (!app) return
    app.addListener('appUrlOpen', ({ url }: { url: string }) => routeUrl(url))
    try {
        const launch = await app.getLaunchUrl()
        routeUrl(launch?.url)
    } catch { /* best-effort — appUrlOpen covers the common path */ }
}

export default { init }
